<template>
  <ul class="timeline">

    <order-change-status-timeline-item v-for="item in items" :item="item"></order-change-status-timeline-item>
    <money-return-likuiduar-timeline-item v-if="barazim != null" :item="barazim"></money-return-likuiduar-timeline-item>

  </ul>
</template>

<script>
import OrderChangeStatusTimelineItem from '@/Shared/OrderChangeStatusTimelineItem'
import MoneyReturnLikuiduarTimelineItem from '@/Shared/MoneyReturnLikuiduarTimelineItem'

export default {

  name: 'OrderChangeStatusTimeline',
  components: {MoneyReturnLikuiduarTimelineItem, OrderChangeStatusTimelineItem},
  props: {
    items: Object,
    barazim: Object
  }
}
</script>
